export const ADMIN_PEOPLE_INVITE_REQUEST = 'admin/PEOPLE_INVITE_REQUEST';
export const ADMIN_PEOPLE_INVITE_SUCCESS = 'admin/PEOPLE_INVITE_SUCCESS';
export const ADMIN_PEOPLE_INVITE_FAILURE = 'admin/PEOPLE_INVITE_FAILURE';
